import React, { useEffect, useRef, useState } from "react";
import portfolio from "../../assets/images/svg/portfolio.svg";
import SelectNuvama from "../SelectNuvama/SelectNuvama";
import { portfolioTabsData, portfolioTabsWithOffshore } from "../../utils/data";
import Modal from "../Modal";
import ModalFamily from "../ModalFamily/ModalFamily";
import FinancialAssetSummary from "../../components/FinancialAssetSummary/FinancialAssetSummary";
import {
  allocSummary,
  family_modal_title,
  financialSummary,
  FINANCIALTAB,
  noDataFinancialAssets,
  noDataOffshore,
  OFFSHORE,
  offshoreAllocSummary,
  offshoretitle,
  PORTFOLIO_PAGE,
} from "../../utils/constants";
import LiabilitiesSummary from "../LiabilitiesSummary/LiabilitiesSummary";
import DerivativesSummary from "../DerivativesSummary/DerivativesSummary";
import RealEstateSummary from "../RealEstateSummary/RealEstateSummary";
import { observer } from "mobx-react";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import PerformanceStore from "../../store/PerformanceStore";
import downArrowBlack from "../../assets/images/svg/downArrowBlack.svg";
import {
  isOffshoreInvestment,
  isOffshoretabVisible,
  logEvents,
  trackEventWithScreen,
} from "../../utils/functions";
import { useLocation, useNavigate, useOutletContext } from "react-router";
import Header from "../Header/Header";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import HomeModals from "../HomeModals/HomeModals";
import NoDataFinancialAssets from "../FinancialAssetSummary/NoDataFinancialAssets";
import OffshoreAssetSummary from "../OffshoreAssetSummary/OffshoreAssetSummary";

import PageTitle from "../PageTitle/PageTitle";
import PageHeading from "../PageHeading/PageHeading";
const PortfolioTabs = observer(() => {
  const context = useOutletContext();
  const controllerRef = useRef(null); // <-- define hook at top level
  const location = useLocation();

  const [selectedMember, setSelectedMember] = useState("0");
  const [openFamilyModal, setOpenFamilyModal] = useState(false);
  const [isOffshoreData, setIsOffshoreData] = useState(false);
  const [currency, setCurrency] = useState({ currency: "" });
  const navigate = useNavigate();

  const withNuvama = UserStore.withNuvama;
  const withOthers = UserStore.withOthers;

  // helper: abort current controller if it exists
  const abortPending = () => {
    if (controllerRef.current) {
      controllerRef.current.abort();
      controllerRef.current = null;
    }
  };

  // helper: create a new controller for the next batch of requests
  const newSignal = () => {
    abortPending(); // abort previous in-flight requests
    controllerRef.current = new AbortController();
    return controllerRef.current.signal;
  };

  const handleTab = (tabsData) => {
    navigate("/portfolio", {
      state: {
        from: tabsData.value,
      },
      replace: true,
    });

    const signal = newSignal(); // abort previous and create fresh signal
    UserStore.setSelectedTab(tabsData.value);
    PerformanceStore.setLoaderClosingCheck({});

    if (tabsData.value !== OFFSHORE || isOffshoreData) {
      PerformanceStore.setCurrentLoader("mainTabLoader");
      PerformanceStore.setPerformanceLoader("mainTabLoader", true);
      UserStore.callApisForTabs(tabsData.value, signal);
    }

    trackEventWithScreen({
      eventName: PORTFOLIO_PAGE,
      screenName: tabsData.show,
    });
    logEvents(PORTFOLIO_PAGE, { screenName: tabsData.show });
  };

  const handleWealth = () => {
    const signal = newSignal(); // abort previous and create fresh signal
    const isOffshore = isOffshoreInvestment();
    setIsOffshoreData(isOffshore);
    function getPortfolio() {
      UserStore.populatePortfolio(
        { isScroll: false, measureId: undefined, signal },
        false,
      );
      UserStore.getQuickViews({ signal });
    }

    UserStore.setPortfolioTabsStatusDefault();
    UserStore.setUserData("offshoreData", {});
    AuthStore.updateLoadingFullScreen(false);
    PerformanceStore.setLoaderClosingCheck({});
    PerformanceStore.setCurrentLoader("mainTabLoader");
    PerformanceStore.setPerformanceLoader("mainTabLoader", true);
    const selectedTab = UserStore.selectedPortfoliotab;
    if (selectedTab === "realEstate") {
      UserStore.getRealEstateData({ signal });
    } else if (selectedTab === "liabilities") {
      UserStore.getLiabilitieslas({ signal });
      UserStore.getLiabilities({ signal });
    } else if (selectedTab === "derivatives") {
      UserStore.getDerivative({ signal });
    } else if (selectedTab === FINANCIALTAB) {
      getPortfolio();
    } else {
      if (isOffshore) {
        UserStore.getOffshoreDataOnFamilyMemberChange({
          isScroll: false,
          signal,
        });
      } else {
        PerformanceStore.loaderCloseFunction();
      }
      // else {
      //   UserStore.setSelectedTab(FINANCIALTAB);
      //   getPortfolio();
      // }
    }
  };

  useEffect(() => {
    if (UserStore.isHydrated) {
      setIsOffshoreData(isOffshoreInvestment());
    }
  }, [UserStore.isHydrated]);

  useEffect(() => {
    // cleanup on unmount: abort whatever is in-flight
    return () => {
      abortPending();
    };
  }, []);

  useEffect(() => {
    const currencyData = location.state?.currency;
    if (currencyData) {
      setCurrency(currencyData);
    }
  }, []);

  useEffect(() => {
    if (isOffshoreData && UserStore.selectedCurrency) {
      setCurrency({ currency: UserStore.selectedCurrency.currency });
    }
  }, [UserStore.selectedCurrency]);

  return (
    <>
      <PageTitle title={"Portfolio"} />
      {AuthStore.isLoadingFullScreen ||
      !UserStore.isHydrated ||
      context.isLoading ||
      PerformanceStore.portfolioAssetPageLoader ||
      (Object.values(UserStore.financialApiStatus).includes("pending") &&
        !PerformanceStore.mainTabLoader) ||
      UserStore.isOffshoreAssetPageLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <Header type="portfolio" />
          <div className="portfolio1_below_header_container">
            <div className="portfolio1_below_header">
              {/* {!location.pathname.includes("_portfolio") && (
                <BreadCrumb
                  locationArr={
                    pathname === "/portfolio" ? [] : UserStore.portfolioPath
                  }
                  //clickFunction={(index, data) => {}}
                  parentName={"portfolio"}
                />
              )} */}
            </div>

            <>
              <div className="tabs_outer_main">
                <div className="tabs_inside_main">
                  <div className="portfoio_tabs">
                    <div className="portfolio_heading">
                      <img className="port_logo" src={portfolio} alt="" />
                      <PageHeading
                        headingClass="port_tag"
                        headingText="Portfolio"
                      />
                    </div>
                    <div className="tab_container">
                      <div className="tabs_part">
                        <div className="tabs port_tabs">
                          <ul>
                            {(!isOffshoretabVisible({
                              isPrimaryUser: UserStore.isSelectedUserPrimary,
                              userData: UserStore.userData,
                            })
                              ? //isOffshoreData
                                portfolioTabsData
                              : portfolioTabsWithOffshore
                            ).map((tabsData) => (
                              <li
                                className={
                                  UserStore.selectedPortfoliotab ===
                                  tabsData?.value
                                    ? "is-active"
                                    : "portfolio_tabs_btn_animation"
                                }
                                onClick={() => handleTab(tabsData)}
                              >
                                {/* <a>{tabsData?.show}</a> */}
                                <button>{tabsData?.show}</button>
                              </li>
                            ))}
                          </ul>
                        </div>

                        <SelectNuvama
                          type={"all"}
                          handleWealth={(title) => handleWealth(title)}
                          setOpenFamilyModal={() => setOpenFamilyModal(true)}
                          withNuvama={withNuvama}
                          withOthers={withOthers}
                          selectedMember={selectedMember}
                          memberDropdownClass="analytics-members-dropdown"
                          memberDropdownTextClass="analytics-members-dropdown-text"
                          downArrowIcon={downArrowBlack}
                          pointerEvent={PerformanceStore.mainTabLoader}
                          disableToggle={
                            UserStore.selectedPortfoliotab === "global"
                          }
                          isInvestmentHeldWithButtonDisabled={
                            UserStore.selectedPortfoliotab === "global"
                          }
                        />
                      </div>
                    </div>
                    {PerformanceStore.mainTabLoader ||
                    (UserStore.isOffshoreAssetTabLoading &&
                      UserStore.selectedPortfoliotab === OFFSHORE) ? (
                      <div
                        className="report_table_loader"
                        style={{ minHeight: "630px" }}
                      >
                        <div className="report_loader_wrapper add_margin">
                          <img
                            style={{ marginBottom: "300px" }}
                            className="loading_gif"
                            src={loaderGIF}
                            alt="loading..."
                          />
                        </div>
                      </div>
                    ) : (
                      <div>
                        {UserStore.selectedPortfoliotab === FINANCIALTAB && (
                          <FinancialAssetSummary
                            isOffshore={false}
                            title={financialSummary}
                            summarytitle={allocSummary}
                            dataPoint={"portfolio"}
                            tabTitle={"financialAssetClasses"}
                            noDataMessage={noDataFinancialAssets}
                          />
                        )}
                        {UserStore.selectedPortfoliotab === "liabilities" && (
                          <LiabilitiesSummary hasData={true} />
                        )}
                        {UserStore.selectedPortfoliotab === "derivatives" && (
                          <DerivativesSummary hasData={true} />
                        )}
                        {UserStore.selectedPortfoliotab === "realEstate" && (
                          <RealEstateSummary hasData={true} />
                        )}
                        {UserStore.selectedPortfoliotab === "global" ? (
                          isOffshoreData ? (
                            <OffshoreAssetSummary
                              title={offshoretitle}
                              isOffshore={isOffshoreData}
                              summarytitle={offshoreAllocSummary}
                              tabTitle={"offshoreInvestment"}
                              currency={
                                currency.currency
                                  ? currency
                                  : UserStore.currencyData?.[0]
                              }
                              dataPoint={"offshoreData"}
                              noDataMessage={noDataOffshore}
                              setCurrency={setCurrency}
                            />
                          ) : (
                            <div className="financial_outside">
                              <NoDataFinancialAssets
                                className={""}
                                alternateText={"no global investment"}
                                message={noDataOffshore}
                              />
                            </div>
                          )
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <Modal
                onClose={() => setOpenFamilyModal(false)}
                open={openFamilyModal}
                title={family_modal_title}
                width={"810px"}
              >
                <ModalFamily
                  setSelectedMember={(id) => setSelectedMember(id)}
                  selectedMember={selectedMember}
                  onClose={() => setOpenFamilyModal(false)}
                />
              </Modal>
            </>
          </div>
        </>
      )}
      <HomeModals />
    </>
  );
});

export default PortfolioTabs;
